import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AnimalSelectionAnimalsComponent } from './animal-selection-animals.component';
import { AnimalSelectionFilterColorsDialogComponent } from './animal-selection-filter-colors-dialog.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { SubscribeDirective } from '@ngneat/subscribe';
import { TranslocoModule } from '@ngneat/transloco';
import { DataTableModule } from '@tcc-mono/shared/ui/data-table';
import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';
import { ListSearchHeaderModule } from '@tcc-mono/shared/ui/list-search-header';
import { SharedUtilsModule } from '@tcc-mono/shared/utils';
import { AnimalSelectionAnimalDialogModule } from '@tcc-mono/vandijk/shared/features/animal-selections/feature/dialogs/animal-selection-animal-dialog';
import { AnimalSelectionAnimalDetailsDialogModule } from '@tcc-mono/vandijk/shared/features/animal-selections/feature/dialogs/animal-selection-animal-details-dialog';
import { AnimalLookupDialogModule } from '@tcc-mono/vandijk/shared/features/animal-lookup-dialog';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    TranslocoModule,
    FontAwesomeModule,
    SharedUtilsModule,
    ListSearchHeaderModule,
    DataTableModule,
    DialogLayoutModule,
    SubscribeDirective,
    AnimalSelectionAnimalDialogModule,
    AnimalSelectionAnimalDetailsDialogModule,
    AnimalLookupDialogModule
  ],
  declarations: [AnimalSelectionAnimalsComponent, AnimalSelectionFilterColorsDialogComponent],
  exports: [AnimalSelectionAnimalsComponent]
})
export class AnimalSelectionAnimalsModule {}
